import { useQuery } from '@apollo/client';

import useDispensary from 'src/dispensary/hooks/use-dispensary';
import {
  DispensarySortByType,
  GetChainDispensariesDocument,
  GetChainDispensariesQueryVariables,
} from 'src/gql/graphql';
import { DispensaryChainReturn } from './types';

export function useDispensaryChains({
  dispensaryId,
  address,
  deliversToAddress = false,
  activeOnly = false,
  includeStealthMode = false,
  skip = false,
}: {
  dispensaryId?: string;
  address?: any;
  deliversToAddress?: boolean;
  activeOnly?: boolean;
  includeStealthMode?: boolean;
  skip?: boolean;
}): DispensaryChainReturn {
  // Get the source dispensary, passing the explicit ID if provided
  const { dispensary } = useDispensary(dispensaryId);

  const variables: GetChainDispensariesQueryVariables = {
    dispensaryFilter: {
      type: `Dispensary`,
      chain: dispensary?.chain,
      nearLat: address?.lat,
      nearLng: address?.lng,
      destinationTaxState: address?.state,
      destinationTaxZipcode: address?.zipcode,
      distance: address ? 1000.0 : null,
      deliversToAddress,
      activeOnly,
      includeStealthMode,
      sortBy: DispensarySortByType.distance,
    },
  };

  const { data, ...apolloValues } = useQuery(GetChainDispensariesDocument, {
    variables,
    skip: !dispensary?.id || skip,
  });

  return {
    dispensaryChainLocations: data?.filteredDispensaries ?? [],
    ...apolloValues,
  };
}
